import React from 'react';
import { useTranslation } from 'react-i18next';
import './SearcherList.css';

export interface Searcher {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  isOnline: boolean;
  gameAddress: string;
  gameDate: string;
  gameTime: string;
}

interface SearcherListProps {
  searchers: Searcher[];
}

const SearcherList: React.FC<SearcherListProps> = ({ searchers }) => {
  const { t } = useTranslation();
  return (
    <div className="searcher-list-container">
      <h6>{t('availableSearchers')}</h6>
      {searchers.length > 0 ? (
        <ul>
          {searchers.map((searcher) => (
            <li key={searcher.id} className="searcher-item">
              <h3>{searcher.name}</h3>
              <p>{t('gameDate')}: {searcher.gameDate} {t('gameTime')}: {searcher.gameTime}</p>
              <p>{t('gameAddress')}: {searcher.gameAddress}</p>
              <p>Status: {searcher.isOnline ? 'Online' : 'Offline'}</p>
              {/* Add more details or actions here */}
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('noSearchersAvailable')}</p>
      )}
    </div>
  );
};

export default SearcherList;